/* @generated from adl module AppCommands */

import * as ADL from './runtime/adl';
import * as Buffer from './Buffer';
import * as ClientState from './ClientState';
import * as InfoRequest from './InfoRequest';
import * as Path from './Path';
import * as Terminal from './Terminal';

export interface Command_RefreshFileTreeView {
  kind: 'refreshFileTreeView';
  value: RefreshFileTreeView;
}
export interface Command_SaveFile {
  kind: 'saveFile';
  value: SaveFile;
}
export interface Command_CloseTab {
  kind: 'closeTab';
  value: CloseTab;
}
export interface Command_EditorBufferChange {
  kind: 'editorBufferChange';
  value: EditorBufferChange;
}
export interface Command_NewFile {
  kind: 'newFile';
  value: NewFile;
}
export interface Command_OpenFile {
  kind: 'openFile';
  value: OpenFile;
}
export interface Command_InfoRequestCommand {
  kind: 'infoRequestCommand';
  value: InfoRequestCommand;
}
export interface Command_NewTerminal {
  kind: 'newTerminal';
  value: NewTerminal;
}
export interface Command_TerminalInputCommand {
  kind: 'terminalInputCommand';
  value: TerminalInputCommand;
}

export type Command = Command_RefreshFileTreeView | Command_SaveFile | Command_CloseTab | Command_EditorBufferChange | Command_NewFile | Command_OpenFile | Command_InfoRequestCommand | Command_NewTerminal | Command_TerminalInputCommand;

export interface CommandOpts {
  refreshFileTreeView: RefreshFileTreeView;
  saveFile: SaveFile;
  closeTab: CloseTab;
  editorBufferChange: EditorBufferChange;
  newFile: NewFile;
  openFile: OpenFile;
  infoRequestCommand: InfoRequestCommand;
  newTerminal: NewTerminal;
  terminalInputCommand: TerminalInputCommand;
}

export function makeCommand<K extends keyof CommandOpts>(kind: K, value: CommandOpts[K]) { return {kind, value}; }

const Command_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"refreshFileTreeView","default":{"kind":"nothing"},"name":"refreshFileTreeView","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"RefreshFileTreeView"}},"parameters":[]}},{"annotations":[],"serializedName":"saveFile","default":{"kind":"nothing"},"name":"saveFile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"SaveFile"}},"parameters":[]}},{"annotations":[],"serializedName":"closeTab","default":{"kind":"nothing"},"name":"closeTab","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"CloseTab"}},"parameters":[]}},{"annotations":[],"serializedName":"editorBufferChange","default":{"kind":"nothing"},"name":"editorBufferChange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"EditorBufferChange"}},"parameters":[]}},{"annotations":[],"serializedName":"newFile","default":{"kind":"nothing"},"name":"newFile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"NewFile"}},"parameters":[]}},{"annotations":[],"serializedName":"openFile","default":{"kind":"nothing"},"name":"openFile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"OpenFile"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequestCommand","default":{"kind":"nothing"},"name":"infoRequestCommand","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"InfoRequestCommand"}},"parameters":[]}},{"annotations":[],"serializedName":"newTerminal","default":{"kind":"nothing"},"name":"newTerminal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"NewTerminal"}},"parameters":[]}},{"annotations":[],"serializedName":"terminalInputCommand","default":{"kind":"nothing"},"name":"terminalInputCommand","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppCommands","name":"TerminalInputCommand"}},"parameters":[]}}]}},"name":"Command","version":{"kind":"nothing"}}};

export const snCommand: ADL.ScopedName = {moduleName:"AppCommands", name:"Command"};

export function texprCommand(): ADL.ATypeExpr<Command> {
  return {value : {typeRef : {kind: "reference", value : snCommand}, parameters : []}};
}

export interface RefreshFileTreeView {
}

export function makeRefreshFileTreeView(
  _input: {
  }
): RefreshFileTreeView {
  return {
  };
}

const RefreshFileTreeView_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"RefreshFileTreeView","version":{"kind":"nothing"}}};

export const snRefreshFileTreeView: ADL.ScopedName = {moduleName:"AppCommands", name:"RefreshFileTreeView"};

export function texprRefreshFileTreeView(): ADL.ATypeExpr<RefreshFileTreeView> {
  return {value : {typeRef : {kind: "reference", value : snRefreshFileTreeView}, parameters : []}};
}

export interface NewFile {
}

export function makeNewFile(
  _input: {
  }
): NewFile {
  return {
  };
}

const NewFile_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"NewFile","version":{"kind":"nothing"}}};

export const snNewFile: ADL.ScopedName = {moduleName:"AppCommands", name:"NewFile"};

export function texprNewFile(): ADL.ATypeExpr<NewFile> {
  return {value : {typeRef : {kind: "reference", value : snNewFile}, parameters : []}};
}

export interface OpenFile {
  filePath: Path.PathRelFile;
}

export function makeOpenFile(
  input: {
    filePath: Path.PathRelFile,
  }
): OpenFile {
  return {
    filePath: input.filePath,
  };
}

const OpenFile_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}}]}},"name":"OpenFile","version":{"kind":"nothing"}}};

export const snOpenFile: ADL.ScopedName = {moduleName:"AppCommands", name:"OpenFile"};

export function texprOpenFile(): ADL.ATypeExpr<OpenFile> {
  return {value : {typeRef : {kind: "reference", value : snOpenFile}, parameters : []}};
}

export interface SaveFile {
  id: ClientState.EditorFileId;
}

export function makeSaveFile(
  input: {
    id: ClientState.EditorFileId,
  }
): SaveFile {
  return {
    id: input.id,
  };
}

const SaveFile_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}}]}},"name":"SaveFile","version":{"kind":"nothing"}}};

export const snSaveFile: ADL.ScopedName = {moduleName:"AppCommands", name:"SaveFile"};

export function texprSaveFile(): ADL.ATypeExpr<SaveFile> {
  return {value : {typeRef : {kind: "reference", value : snSaveFile}, parameters : []}};
}

export interface CloseTab {
  id: ClientState.EditorFileId;
}

export function makeCloseTab(
  input: {
    id: ClientState.EditorFileId,
  }
): CloseTab {
  return {
    id: input.id,
  };
}

const CloseTab_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}}]}},"name":"CloseTab","version":{"kind":"nothing"}}};

export const snCloseTab: ADL.ScopedName = {moduleName:"AppCommands", name:"CloseTab"};

export function texprCloseTab(): ADL.ATypeExpr<CloseTab> {
  return {value : {typeRef : {kind: "reference", value : snCloseTab}, parameters : []}};
}

export interface EditorBufferChange {
  id: ClientState.EditorFileId;
  changes: Buffer.BufferChange[];
}

export function makeEditorBufferChange(
  input: {
    id: ClientState.EditorFileId,
    changes: Buffer.BufferChange[],
  }
): EditorBufferChange {
  return {
    id: input.id,
    changes: input.changes,
  };
}

const EditorBufferChange_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}},{"annotations":[],"serializedName":"changes","default":{"kind":"nothing"},"name":"changes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Buffer","name":"BufferChange"}},"parameters":[]}]}}]}},"name":"EditorBufferChange","version":{"kind":"nothing"}}};

export const snEditorBufferChange: ADL.ScopedName = {moduleName:"AppCommands", name:"EditorBufferChange"};

export function texprEditorBufferChange(): ADL.ATypeExpr<EditorBufferChange> {
  return {value : {typeRef : {kind: "reference", value : snEditorBufferChange}, parameters : []}};
}

export interface InfoRequestCommand {
  id: InfoRequest.InfoRequestId;
  infoRequest: InfoRequest.InfoRequest;
}

export function makeInfoRequestCommand(
  input: {
    id: InfoRequest.InfoRequestId,
    infoRequest: InfoRequest.InfoRequest,
  }
): InfoRequestCommand {
  return {
    id: input.id,
    infoRequest: input.infoRequest,
  };
}

const InfoRequestCommand_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequest","default":{"kind":"nothing"},"name":"infoRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequest"}},"parameters":[]}}]}},"name":"InfoRequestCommand","version":{"kind":"nothing"}}};

export const snInfoRequestCommand: ADL.ScopedName = {moduleName:"AppCommands", name:"InfoRequestCommand"};

export function texprInfoRequestCommand(): ADL.ATypeExpr<InfoRequestCommand> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequestCommand}, parameters : []}};
}

export interface NewTerminal {
  params: Terminal.TerminalCreateParams;
}

export function makeNewTerminal(
  input: {
    params: Terminal.TerminalCreateParams,
  }
): NewTerminal {
  return {
    params: input.params,
  };
}

const NewTerminal_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"params","default":{"kind":"nothing"},"name":"params","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TerminalCreateParams"}},"parameters":[]}}]}},"name":"NewTerminal","version":{"kind":"nothing"}}};

export const snNewTerminal: ADL.ScopedName = {moduleName:"AppCommands", name:"NewTerminal"};

export function texprNewTerminal(): ADL.ATypeExpr<NewTerminal> {
  return {value : {typeRef : {kind: "reference", value : snNewTerminal}, parameters : []}};
}

export interface TerminalInputCommand {
  id: ClientState.TerminalId;
  command: Terminal.TerminalCommand;
}

export function makeTerminalInputCommand(
  input: {
    id: ClientState.TerminalId,
    command: Terminal.TerminalCommand,
  }
): TerminalInputCommand {
  return {
    id: input.id,
    command: input.command,
  };
}

const TerminalInputCommand_AST : ADL.ScopedDecl =
  {"moduleName":"AppCommands","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TerminalId"}},"parameters":[]}},{"annotations":[],"serializedName":"command","default":{"kind":"nothing"},"name":"command","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TerminalCommand"}},"parameters":[]}}]}},"name":"TerminalInputCommand","version":{"kind":"nothing"}}};

export const snTerminalInputCommand: ADL.ScopedName = {moduleName:"AppCommands", name:"TerminalInputCommand"};

export function texprTerminalInputCommand(): ADL.ATypeExpr<TerminalInputCommand> {
  return {value : {typeRef : {kind: "reference", value : snTerminalInputCommand}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "AppCommands.Command" : Command_AST,
  "AppCommands.RefreshFileTreeView" : RefreshFileTreeView_AST,
  "AppCommands.NewFile" : NewFile_AST,
  "AppCommands.OpenFile" : OpenFile_AST,
  "AppCommands.SaveFile" : SaveFile_AST,
  "AppCommands.CloseTab" : CloseTab_AST,
  "AppCommands.EditorBufferChange" : EditorBufferChange_AST,
  "AppCommands.InfoRequestCommand" : InfoRequestCommand_AST,
  "AppCommands.NewTerminal" : NewTerminal_AST,
  "AppCommands.TerminalInputCommand" : TerminalInputCommand_AST
};
